import script from "./VinInputPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VinInputPage.vue?vue&type=script&setup=true&lang=js"

import "./VinInputPage.vue?vue&type=style&index=0&id=e7a7f790&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7a7f790"]])

export default __exports__